import { Button, Tooltip, useAppContext } from "@dit/core-frontend"
import React, { memo, useCallback } from "react"
import { buttonProps } from "./buttonProps"
import { LinkIcon } from "../../theme/editorIcons"
import { insertLink } from "../../utils/insertLink"

export const InsertLinkButton = memo(({ activeEditor, isEditable, setIsLinkEditMode }) => {
  const { showAlert } = useAppContext()

  const handleInsertLink = useCallback(() => {
    insertLink(activeEditor, setIsLinkEditMode, showAlert)
  }, [activeEditor, setIsLinkEditMode, showAlert])

  return (
    <Tooltip content="Добавление ссылки">
      <Button {...buttonProps} kind="borderless" disabled={!isEditable} onClick={handleInsertLink}>
        <span>
          <LinkIcon />
        </span>
      </Button>
    </Tooltip>
  )
})
InsertLinkButton.displayName = "InsertLinkButton"
